var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "slide-fade-left" } }, [
    _vm.product
      ? _c(
          "div",
          {
            staticClass: "sidecart__line-item",
            class: _vm.itemClass,
            attrs: { "data-variantId": _vm.item.id },
          },
          [
            _c("div", { staticClass: "sidecart__line-item__image-wrapper" }, [
              _c("img", {
                staticClass: "sidecart__line-item__image",
                attrs: { src: _vm.thumbnail, alt: _vm.item.product_title },
              }),
            ]),
            _c("div", { staticClass: "sidecart__line-item__content" }, [
              _c(
                "div",
                {
                  staticClass: "sidecart__line-item__details",
                  attrs: { "data-handle": _vm.item.handle },
                },
                [
                  _c("p", { staticClass: "sidecart__line-item__title" }, [
                    _vm._v(_vm._s(_vm.cleanedTitle)),
                  ]),
                  _c("p", { staticClass: "sidecart__line-item__price" }, [
                    !_vm.isDiscounted
                      ? _c(
                          "span",
                          {
                            class: {
                              "sidecart__line-item__price--discount":
                                _vm.isDiscounted,
                            },
                          },
                          [_vm._v(_vm._s(_vm._f("money")(_vm.item.line_price)))]
                        )
                      : _vm._e(),
                    _vm.isDiscounted
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "sidecart__line-item__price--compare-at",
                          },
                          [_vm._v(_vm._s(_vm._f("money")(_vm.originalPrice)))]
                        )
                      : _vm._e(),
                    _vm.isDiscounted
                      ? _c(
                          "span",
                          {
                            staticClass: "sidecart__line-item__price--discount",
                          },
                          [_vm._v(_vm._s(_vm._f("money")(_vm.comparePrice)))]
                        )
                      : _vm._e(),
                    _vm.isDiscounted
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "sidecart__line-item__price--discount-percent",
                          },
                          [_vm._v(_vm._s(_vm.savingsText))]
                        )
                      : _vm._e(),
                  ]),
                  _vm.hasVariantTitle
                    ? _c("p", { staticClass: "sidecart__line-item__variant" }, [
                        _vm._v(_vm._s(_vm.cleanedVariantTitle)),
                      ])
                    : _vm._e(),
                  _vm.purchaseFrequency
                    ? _c(
                        "p",
                        { staticClass: "sidecart__line-item__frequency" },
                        [
                          _c("icon", {
                            staticClass: "sidecart__line-item__frequency-icon",
                            attrs: {
                              name: "reoccuring",
                              width: "16px",
                              height: "16px",
                            },
                          }),
                          _vm._v(_vm._s(_vm.purchaseFrequency)),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              _c(
                "div",
                { staticClass: "sidecart__line-item__controls" },
                [
                  _c("icon-button", {
                    staticClass: "sidecart__line-item__remove",
                    attrs: {
                      label: "Remove " + _vm.item.product_title,
                      icon: "close",
                      width: "10px",
                      height: "10px",
                    },
                    on: { click: _vm.removeItem },
                  }),
                  _c("sidecart-quantity-selector", {
                    attrs: {
                      quantity: _vm.item.quantity,
                      "disabled-increment": _vm.isGiftWithPurchase,
                    },
                    on: { increment: _vm.increment, decrement: _vm.decrement },
                  }),
                ],
                1
              ),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }